import { GTR } from "../../common/apiUrl/gtr/gtrUrls";
import { API } from "../../common/model/objectTypes";
import { deliveredGatherInfo } from "../../utils/apiDescription/gtr/deliveredGather";
import { API_BASE_URL } from "../../utils/constants";
import { deleteAndArchiveDeliveredGatherRequestBody } from "../../utils/gtr/apiObjects";
import { archiveDeliveredGatherJsonRequestCurl, deleteDeliveredGatherJsonRequestCurl } from "../../utils/gtr/sampleJsonRequest";
import { commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";

const DeleteDeliveredGather : API = {
    name: "Delete Delivered Gather",
    url: `${API_BASE_URL}/${GTR.DELIVERED.DELETE_DELIVERED_GTR_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredGatherInfo.deleteDeliveredGather,
    requestBody: deleteAndArchiveDeliveredGatherRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteDeliveredGatherJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const ArchiveDeliveredGather : API = {
    name: "Archive Delivered Gather",
    url: `${API_BASE_URL}/${GTR.DELIVERED.ARCHIVE_GTR_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredGatherInfo.archiveDeliveredGather,
    requestBody: deleteAndArchiveDeliveredGatherRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveDeliveredGatherJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case "Delivered Gather":
            return DeleteDeliveredGather;
        case "Archive":
            return ArchiveDeliveredGather;
        
    }
}